import React, { useEffect, useState } from 'react';

import { useInspectorStyles } from './styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import { IMediaStatus } from '../../global/interfaces';

const messages = [
  {
    event: 'invite-link-sent',
    message: 'SMS invitation sent to $mobile_number.',
  },
  {
    event: 'welcome-page-visited',
    message: 'Invitee clicked the link.',
  },
  {
    event: 'media-access-video',
    message: 'Camera is accessible',
  },
  {
    event: 'media-access-audio',
    message: 'Microphone is accessible',
  },
  {
    event: 'ready-to-join',
    message: 'Invitee is ready to join the session.',
  },
];

const WaitingModalMessage = ({
  mediaStatus,
  mobileNumber,
}: {
  mediaStatus: IMediaStatus[] | undefined;
  mobileNumber: string;
}) => {
  const styles = useInspectorStyles();

  const [statusResult, setStatusResult] = useState<
    Record<string, boolean | undefined>
  >({});

  useEffect(() => {
    console.log('::::resetting statusResult...');
    setStatusResult({});
  }, []);

  useEffect(() => {
    if (!mediaStatus?.length) return;

    console.log('::::mediaStatus:', mediaStatus);

    for (let i = mediaStatus.length - 1; i >= 0; i--) {
      const status = mediaStatus[i];
      if (!status.timestamp || !status.event) return;

      console.log('::::status:', status);

      switch (status.event) {
        case 'invite-link-error':
          statusResult['invite-link-sent'] = false;
          break;

        case 'media-access-error-audio':
          statusResult['media-access-audio'] = false;
          break;

        case 'media-access-error-video':
          statusResult['media-access-video'] = false;
          break;

        default:
          statusResult[status.event] = true;
          break;
      }

      setStatusResult({ ...statusResult });

      if (
        status.event === 'invite-link-error' ||
        status.event === 'invite-link-sent'
      ) {
        break;
      }
    }
  }, [mediaStatus]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        paddingTop: '1rem',
      }}>
      {messages.map((status, index) => {
        return (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}>
            <Box
              width={'1.75rem'}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {statusResult[status.event] === undefined ? (
                <></>
              ) : statusResult[status.event] === false ? (
                <ErrorOutlineIcon color="error" fontSize="small" />
              ) : (
                <CheckCircleOutlineIcon color="success" fontSize="small" />
              )}
            </Box>
            <Typography
              sx={{
                ...styles.modalSub,
                color:
                  statusResult[status.event] === undefined ? '#888' : '#fff',
              }}>
              {status.message.replace('$mobile_number', mobileNumber)}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default WaitingModalMessage;
